
app.homeController = app.homeController || {};
app.homeController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.actuSlider();
    },

    actuSlider : function () {
        var self = this;
        var footer = $('footer');

        $('.actu-slider').slick({
            arrows: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 3000
        });

        $('.actu-prev').on('click', function() {
            $('.actu-slider').slick('slickPrev');
        });

        $('.actu-next').on('click', function() {
            $('.actu-slider').slick('slickNext');
        });

        self.resizeSlider(footer);

        $( window ).resize(function() {
            self.resizeSlider(footer);
        });
    },

    resizeSlider : function (footer) {
        var blk1 = $('footer .footer-left-1');
        var blk2 = $('footer .footer-right-1');

        blk1.css('width', (footer.width() - 40 - blk2.width()) + 'px');

        var height = footer.height() + 40;
        var homeContent = $('.home-content');
        var body = $('body').height();

        homeContent.css('height', (body - height) + 'px');
    }
        
};
